export const PRODUCT_FLYOUT_PARAM_NAME = 'produkt';
export const INVOICE_FLYOUT_PARAM_NAME = 'faktura';
export const HOUSEHOLD_MEMBER_FLYOUT_PARAM_NAME = 'husstandsmedlem';

export const NEW_HOUSEHOLD_MEMBER_PARAM_VALUE = 'ny';

export const FLYOUT_PARAM_NAMES = [
  PRODUCT_FLYOUT_PARAM_NAME,
  INVOICE_FLYOUT_PARAM_NAME,
  HOUSEHOLD_MEMBER_FLYOUT_PARAM_NAME,
] as const;

export type FlyoutParamName = (typeof FLYOUT_PARAM_NAMES)[number];

// A param without a value, such as ?faktura, gives an empty string.
export const getFlyoutParam = (search: string, name: FlyoutParamName): string | null =>
  new URLSearchParams(search).get(name);

export const getSearchWithFlyoutParam = (search: string, name: FlyoutParamName, value: string | null): string => {
  const params = new URLSearchParams(search);
  if (value === null) params.delete(name);
  else params.set(name, value);
  const query = params.toString();
  return query ? `?${query}` : '';
};
